var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 162,
    viewBox: "0 0 552 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_417_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6028 107.829H44.5992C43.5076 107.83 42.4501 107.449 41.609 106.754C40.7679 106.058 40.1959 105.09 39.9916 104.018L26.7734 34.6373H50.7771C51.8695 34.6366 52.9281 35.0168 53.7704 35.7125C54.6128 36.4081 55.1862 37.3756 55.392 38.4484L68.6028 107.829Z",
    fill: "#E43A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5866 107.829H47.6719L72.0736 52.0635H92.9883L68.5866 107.829Z",
    fill: "#C5312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.421 107.829H86.4316C85.3371 107.829 84.2769 107.447 83.4342 106.748C82.5916 106.05 82.0194 105.079 81.8167 104.003L72.0781 52.0635H96.0744C97.168 52.0637 98.2272 52.4463 99.0687 53.1449C99.9101 53.8436 100.481 54.8144 100.682 55.8893L110.421 107.829Z",
    fill: "#E43A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.391 107.829H89.4766L127.819 20.6902H148.734L110.391 107.829Z",
    fill: "#FF9B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.881 20.6902H141.608L128.581 45.7903H104.18L127.881 20.6902Z",
    fill: "#FF9B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3024 109.514L63.7383 71.1327L61.8136 70.3086L45.3777 108.69L47.3024 109.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4938 108.819L105.93 70.4369L104.005 69.6128L87.5691 107.995L89.4938 108.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5944 92.4439L71.9062 51.4054L69.8484 51.7909L77.5365 92.8294L79.5944 92.4439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46 34.1666L225.575 95.1024H207.607L197.885 54.9993L187.816 95.1024H169.848L154.397 34.1666H170.282L179.049 78.523L189.899 34.1666H206.218L216.635 78.523L225.488 34.1666H241.46ZM263.748 34.1666V95.1024H248.904V34.1666H263.748ZM297.334 34.1666C303.757 34.1666 309.37 35.4397 314.174 37.9859C318.977 40.5321 322.68 44.12 325.284 48.7495C327.946 53.3211 329.277 58.6161 329.277 64.6345C329.277 70.595 327.946 75.89 325.284 80.5195C322.68 85.149 318.948 88.7368 314.087 91.2831C309.284 93.8293 303.699 95.1024 297.334 95.1024H274.504V34.1666H297.334ZM296.379 82.2555C301.992 82.2555 306.361 80.722 309.486 77.655C312.611 74.5879 314.174 70.2478 314.174 64.6345C314.174 59.0212 312.611 54.6521 309.486 51.5272C306.361 48.4023 301.992 46.8398 296.379 46.8398H289.348V82.2555H296.379ZM375.505 84.3388H352.763L349.117 95.1024H333.579L355.627 34.1666H372.815L394.863 95.1024H379.151L375.505 84.3388ZM371.686 72.8808L364.134 50.5724L356.669 72.8808H371.686ZM442.023 53.4369C440.924 51.4115 439.332 49.8779 437.249 48.8363C435.224 47.7368 432.822 47.187 430.044 47.187C425.241 47.187 421.393 48.7784 418.499 51.9612C415.606 55.0861 414.159 59.2816 414.159 64.5477C414.159 70.161 415.664 74.559 418.673 77.7418C421.74 80.8667 425.936 82.4291 431.26 82.4291C434.905 82.4291 437.972 81.5032 440.461 79.6514C443.007 77.7996 444.859 75.1377 446.016 71.6656H427.18V60.7283H459.471V74.5301C458.371 78.2337 456.49 81.6769 453.828 84.8596C451.224 88.0424 447.897 90.6176 443.846 92.5851C439.795 94.5527 435.224 95.5364 430.131 95.5364C424.113 95.5364 418.731 94.2344 413.986 91.6303C409.298 88.9683 405.624 85.2937 402.962 80.6063C400.358 75.9189 399.056 70.566 399.056 64.5477C399.056 58.5293 400.358 53.1765 402.962 48.4891C405.624 43.7439 409.298 40.0692 413.986 37.4651C418.673 34.8031 424.026 33.4721 430.044 33.4721C437.336 33.4721 443.47 35.2371 448.447 38.7671C453.481 42.2971 456.809 47.187 458.429 53.4369H442.023ZM505.625 84.3388H482.883L479.237 95.1024H463.7L485.748 34.1666H502.935L524.983 95.1024H509.271L505.625 84.3388ZM501.806 72.8808L494.254 50.5724L486.789 72.8808H501.806Z",
    fill: "#E43A36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_417_493",
    x: 0.732477,
    y: 0,
    width: 552.308,
    height: 182.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26.041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.0205
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_417_493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_417_493",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoWhite);
export default __webpack_public_path__ + "static/media/icon-logo-white.4c1c948cb4d50601bd5c6d734ca3eca8.svg";
export { ForwardRef as ReactComponent };